import React, { Component } from 'react';
import { connect } from 'react-redux';
import withBackend from '../../backend/withBackend';
import { compose } from 'redux';
import { setUser } from '../../actions';
import AdminHeader from '../../components/AdminHeader';

class AdminHeaderContainer extends Component {
  render() {
    const { userData, setUser, firebase } = this.props;
    return <AdminHeader userData={userData} firebase={firebase} setUser={setUser} />;
  }
}

export default compose(
  connect(null, { setUser }),
  withBackend
)(AdminHeaderContainer);